<template>
    <div class="flex gap-3 mb-[20px]">
        <label
            class="flex items-center gap-2 px-3 py-2 rounded-full border-[1px]  cursor-pointer transition-all duration-200"
            :class="selected === 'credit' ? 'bg-[#BA90C6] text-white !border-[#BA90C6]' : 'border-[#ccc] bg-[#EFEFEF] text-[#333333]'"
>
            <input
v-model="selected" type="radio" name="payment" value="credit"
                class="appearance-none w-5 h-5 !border-2 border-[#ccc] bg-[#fff] rounded-full relative checked:border-white checked:w-5 checked:h-5 checked:!border-4 checked:!bg-transparent"
>
            <span class="text-[14px] font-regular font-roboto contents">Credit Card</span>
        </label>
        <!-- <label
            class="flex items-center gap-2 px-3 py-2 rounded-full border-[1px]  cursor-pointer transition-all duration-200"
            :class="selected === 'bank' ? 'bg-[#BA90C6] text-white border-[#BA90C6]' : 'border-[#ccc] bg-[#EFEFEF] text-[#333333]'">
            <input type="radio" name="payment" value="bank" v-model="selected"
                class="appearance-none w-5 h-5 !border-2 border-[#ccc] bg-[#fff] rounded-full relative checked:border-white checked:w-5 checked:h-5 checked:!border-4 checked:!bg-transparent" />
            <span class="text-[14px] font-regular font-roboto contents">Bank Account</span>
        </label> -->
    </div>
    <div v-if="selected === 'credit'" class="flex flex-col gap-[15px]">
        <div class="flex flex-col gap-[3px]">
            <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardholder">Cardholder
                Name<span class="ml-1 text-red-500">*</span></label>
            <inputComponent
ref="cardHolderName" v-model="cardHolderName" name="cardholder" required placeholder="Full name on card"
                length="120" error-message="Invalid Cardholder Name"
                custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardnumber">Card
                Number<span class="ml-1 text-red-500">*</span></label>
            <div class="relative">
                <div id="card-number" class="min-h-[38px] py-[10px] px-3 rounded-lg border border-[#cccccc]" />
                <div id="card-number-error" class="" />
            </div>
        </div>
        <div class="grid grid-cols-2 gap-[30px]">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardexpiry">Expiry<span
                        class="ml-1 text-red-500"
>*</span></label>
                <div class="relative">
                    <div id="card-expiry" class="min-h-[38px] py-[10px] px-3 rounded-lg border border-[#cccccc]" />
                    <div id="card-expiry-error" class="" />
                </div>
            </div>
            <div class="flex flex-col gap-[3px]">
                <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardCVC">CVC<span
                        class="ml-1 text-red-500"
>*</span></label>
                <div class="relative">
                    <div id="card-cvc" class="min-h-[38px] py-[10px] px-3 rounded-lg border border-[#cccccc]" />
                    <div id="card-cvc-error" class="" />
                </div>
            </div>
        </div>
    </div>
    <div v-else class="flex flex-col gap-[15px]">
        <div class="flex flex-col gap-[3px]">
            <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardholder">Account Title<span
                    class="ml-1 text-red-500"
>*</span></label>
            <inputComponent
ref="" v-model="accountTitle" name="cardholder" required placeholder="Enter Account Title"
                length="120" error-message="Invalid Account Title"
                custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardholder">Routing
                Number<span class="ml-1 text-red-500">*</span></label>
            <inputComponent
ref="" v-model="rountingNumber" name="cardholder" required placeholder="Enter Routing Number"
                length="120" error-message="Invalid Routing Number"
                custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardholder">Account Type<span
                    class="ml-1 text-red-500"
>*</span></label>
            <inputComponent
ref="" v-model="accountType" name="cardholder" required placeholder="Enter Account Type"
                length="120" error-message="Invalid Account Type"
                custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="cardholder">Account
                Number<span class="ml-1 text-red-500">*</span></label>
            <inputComponent
ref="" v-model="accountNumber" name="cardholder" required placeholder="Enter Account Number"
                length="120" error-message="Invalid Account Number"
                custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
        </div>
    </div>
    <div class="flex flex-col gap-[15px] mt-[20px]">
        <div>
            <label
                class="relative flex items-center gap-2 cursor-pointer select-none text-[14px] font-medium w-max text-[#666666] "
>
                <input
v-model="checkboxes.terms" type="checkbox" class="appearance-none min-w-[30px] min-h-[30px] w-[30px] h-[30px] border-[1px] border-[#ccc] rounded-[5px] relative
              checked:border-[#A084E8] transition-colors duration-200
             flex items-center justify-center"
>
                <span class="text-[14px] font-roboto font-regular text-[#666666]">I agree to the <a
                        href="/terms-and-conditions" target="_blank" class="text-[#A084E8] focus:outline-none"
> Terms and
                        Conditions</a></span>
                <!-- Checkmark -->
                <div class="absolute top-0 left-0 w-[30px] h-[30px] flex items-center justify-center">
                    <svg
v-if="checkboxes.terms" class="w-[20px] h-[20px]  text-[#A084E8] pointer-events-none"
                        fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
            </label>
        </div>
        <div>
            <label
                class="relative flex items-start gap-2 cursor-pointer select-none text-[14px] font-medium text-[#666666]"
>
                <input
v-model="checkboxes.billing" type="checkbox" class="appearance-none min-w-[30px] min-h-[30px] w-[30px] h-[30px] border-[1px] border-[#ccc] rounded-[5px] relative
              checked:border-[#A084E8] transition-colors duration-200
             flex items-center justify-center"
>
                <span class="text-[14px] font-roboto font-regular text-[#666666]">A charge in the amount of $24.99
                    will
                    be billed to your credit card monthly as NRG Protects 855-334-3571. The first bill charge will
                    be
                    submitted for payment today. You should see a charge to your credit card for the plan within 5
                    days,
                    and 11 subsequent charges will be billed to your credit card for payment about the same day each
                    month. Unless canceled, this contract will automatically renew at the standard term. This plan
                    may
                    be canceled at any time by you and any refund determined in accordance with the plan terms and
                    conditions. Check the box to indicate you understand and agree to these terms today, Nov 21,
                    2024.</span>
                <!-- Checkmark -->
                <div class="absolute top-0 left-0 w-[30px] h-[30px] flex items-center justify-center">
                    <svg
v-if="checkboxes.billing" class="w-[20px] h-[20px]  text-[#A084E8] pointer-events-none"
                        fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
            </label>
        </div>
        <div>
            <label
                class="relative flex items-start gap-2 cursor-pointer select-none text-[14px] font-medium text-[#666666]"
>
                <input
v-model="checkboxes.age" type="checkbox" class="appearance-none min-w-[30px] min-h-[30px] w-[30px] h-[30px] border-[1px] border-[#ccc] rounded-[5px] relative
              checked:border-[#A084E8] transition-colors duration-200
             flex items-center justify-center"
>
                <span class="text-[14px] font-roboto font-regular text-[#666666]">I am at least 18 years of age,
                    authorized to incur charges and the authorized decision maker for the property at 7080 Alliance
                    Road
                    Northwest, Malvern, Ohio 44644, United States. Malvern, OH 44644, and would like to enroll in
                    Cooling Repair and Maintenance PLUS Plan through NRG Protects. The cost of this program is
                    $24.99/month. I understand that there’s a contract term of 12 months. I also understand that
                    this
                    plan may be canceled at any time within 10 days of enrollment and you will receive a refund for
                    services not yet performed, as set forth in the Terms and Conditions. The refund may be less the
                    cost of any paid but unissued billed services, offense, the normal foundation, any open or
                    delinquent balances from this or other repair and/or service agreements, and applicable
                    taxes—and
                    also a waiting period may occur. The purchase of this plan before repair services or
                    reimbursements,
                    as applicable, can be requested. Other charges, fees, costs, adjustments, additions, and any
                    applicable cash-back options with any NRG Protect obligations as set forth in the Terms and
                    Conditions. Also, by accepting the Terms and Conditions will default date of the main bill
                    version
                    within 7–10 days. If no claim, if you have any questions regarding your recurring payment, or
                    would
                    like to revoke your authorization, please contact us at 1.855.241.9094.</span>
                <!-- Checkmark -->
                <div class="absolute top-0 left-0 w-[30px] h-[30px] flex items-center justify-center">
                    <svg
v-if="checkboxes.age" class="w-[20px] h-[20px]  text-[#A084E8] pointer-events-none" fill="none"
                        stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
            </label>
        </div>
        <div>
            <label
                class="relative flex items-start gap-2 cursor-pointer select-none text-[14px] font-medium text-[#666666]"
>
                <input
v-model="checkboxes.protection" type="checkbox" class="appearance-none min-w-[30px] min-h-[30px] w-[30px] h-[30px] border-[1px] border-[#ccc] rounded-[5px] relative
              checked:border-[#A084E8] transition-colors duration-200
             flex items-center justify-center"
>
                <span class="text-[14px] font-roboto font-regular text-[#666666]">By checking this box, I am
                    requesting
                    to be enrolled in the protection plan I selected, and I acknowledge that this is not an
                    insurance
                    policy. I understand NRG Protects protection plans are provided and administered by NRG
                    Protects,
                    Inc., 910 Louisiana St., Houston, TX 77002, 1.855.241.9094, and that I should look to NRG
                    Protects
                    for all obligations under the protection plan. I also understand that my decision to purchase a
                    protection plan will not affect my utility service(s). I affirm the sale of services from NRG
                    Protects I have read, in their entirety, the sample Terms and Conditions for the protection
                    plan(s),
                    and understand there are Terms and Conditions that may limit my coverage due to coverage caps,
                    coverage exclusions, and any cash-back options.
                </span>
                <!-- Checkmark -->
                <div class="absolute top-0 left-0 w-[30px] h-[30px] flex items-center justify-center">
                    <svg
v-if="checkboxes.protection" class="w-[20px] h-[20px]  text-[#A084E8] pointer-events-none"
                        fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
            </label>
        </div>
        <div class="w-full py-[20px]">
            <div class="flex items-center justify-between w-full pb-1.5">
                <label
for="consumersignature"
                    class="text-[16px] font-normal font-roboto text-[#666666] w-full"
>Customer
                    Signature<span class="ml-1 text-red-500">*</span></label>
                <button
type="button" :disabled="!isSignatureValid" class="group text-[14px] mobile:w-6 mobile:h-6 laptop:w-[90px] laptop:h-7 flex justify-center items-center gap-1.5 transition-all rounded-full border-[1px] border-[#F67280] bg-[#F67280]
                        disabled:hover:!bg-[#EFEFEF]  disabled:bg-[#EFEFEF] disabled:border-[#EFEFEF]" @click="clearSignature"
>
                    <span
                        class="laptop:flex mobile:hidden group-hover:text-white text-[#fff] group-disabled:text-[#999999] group-disabled:hover:text-[#999999]"
>
                        Clear
                    </span>
                    <img
src="../../../assets/images/razer-white-icon.svg" alt="razer icon"
                        class="w-[14px] h-[14px] object-contain group-disabled:hidden"
>
                    <img
src="../../../assets/images/razer-icon.png" alt="razer icon"
                        class="w-[14px] h-[14px] object-contain filter hidden group-disabled:block group-disabled:invert-[60%] group-disabled:brightness-0"
>
                </button>
            </div>
            <div class="w-full h-[100px]">
                <VueSignaturePad
ref="signaturePad" height="100%" width="100%" :options="{
                    onBegin: onBegin,
                    onEnd: onEnd
                }"
                    class="!text-base font-medium border border-[#cccccc] outline-none py-2 px-3 w-full rounded-lg placeholder:text-[#cccccc] text-#666666 resize-none"
/>
            </div>
        </div>
    </div>
    <div class="flex justify-center mt-[30px]">
        <button
:disabled="!validationCheck"
            class="px-[30px] py-[8px] text-[16px] font-roboto rounded-full transition duration-300 border-[1px] border-[#00B7C2] text-[#00B7C2] hover:bg-[#00B7C2] hover:text-[#fff] [@media(max-width:1023px)]:!bg-[#00B7C2] [@media(max-width:1023px)]:!text-[#fff] disabled:hover:!bg-transparent disabled:hover:text-unset disabled:bg-transparent disabled:text-[#CCCCCC] disabled:border-[#CCCCCC]"
            @click="submitForm"
>
Confirm
            Purchase
</button>
    </div>
</template>
<script>
import { globals } from "../../../main";
import inputComponent from '../../partialComponent/inputComponent.vue';
import { useToast } from "vue-toastification";
const toast = useToast();
export default {

    components: {
        inputComponent
    },
    props: ["stripe_id"],
    data() {
        return {
            selected: "credit",
            accountTitle: null,
            rountingNumber: null,
            accountType: null,
            accountNumber: null,
            checkboxes: {
                terms: false,
                billing: false,
                age: false,
                protection: false,
            },
            isValid: false,
            isSignatureValid: false,
            signationImageFile: null,
            saveSignatureTimeout: null,
            token: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            cardHolderName: null,
            cardNumberError: null,
            cardExpiryError: null,
            cardCvcError: null,
            cardNumberValid: false,
            cardExpiryValid: false,
            cardCvcValid: false,
            cardBrand: null
        }
    },

    computed: {

        stripeElements() {
            return this.$stripe.elements({
                fonts: [
                    {
                        cssSrc: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
                    },
                ],
            });
        },

        validationCheck() {
            if (this.$helper.isEmpty(this.cardHolderName)) return false;
            if (!this.cardNumberValid) return false
            if (!this.cardExpiryValid) return false
            if (!this.cardCvcValid) return false
            if (!this.checkboxes.terms ||
                !this.checkboxes.billing ||
                !this.checkboxes.age ||
                !this.checkboxes.protection
            ) return false
            if (!this.isSignatureValid) return false
            return true;
        },
    },

    watch: {
        'stripe_id': {
            handler(value) {
                if (this.stripe_id) {
                    setTimeout(() => {
                        this.create()
                    }, 50);
                }
            },
            immediate: true,
        },

    },

    mounted() {

    },

    methods: {
        reset() {
            this.isValid = false
            this.isSignatureValid = false
            this.signationImageFile = null
            this.saveSignatureTimeout = null
            this.token = null
            this.cardHolderName = null
            this.cardNumberError = ''
            this.cardExpiryError = ''
            this.cardCvcError = ''
            this.cardNumberValid = false
            this.cardExpiryValid = false
            this.cardCvcValid = false
            this.cardBrand = ''
            this.checkboxes = {
                terms: false,
                billing: false,
                age: false,
                protection: false,
            }
            document.getElementById('card-number-error').innerHTML = ''
            document.getElementById('card-expiry-error').innerHTML = ''
            document.getElementById('card-cvc-error').innerHTML = ''
            this.destroy()
            this.create()
            this.clearSignature()
            if (this.$refs.cardHolderName) {
                this.$refs.cardHolderName.resetField()
            }

        },

        create() {
            globals.$loader.show();
            const style = {
                base: {
                    color: 'black',
                    fontFamily: '"Lato", sans-serif',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#ccccd1',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                },
            };


            if (this.$stripe == null) {
                this.$stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, {
                    stripeAccount: this.stripe_id + ""
                })

            }
            this.cardNumber = this.stripeElements.create('cardNumber', {
                style,
                disableLink: true,
            });

            this.cardNumber.mount('#card-number');
            this.cardExpiry = this.stripeElements.create('cardExpiry', { style });
            this.cardExpiry.mount('#card-expiry');
            this.cardCvc = this.stripeElements.create('cardCvc', { style });
            this.cardCvc.mount('#card-cvc');

            this.cardNumber.on("change", (event) => {

                // brand detect
                this.cardBrand = event.brand && event.brand !== "unknown"
                    ? (event.brand == 'visa' ? 'card-icon-1'
                        : event.brand == 'mastercard' ? 'card-icon-2'
                            : event.brand == 'amex' ? 'card-icon-3'
                                : null) : null;

                if (event.error) {
                    this.cardNumberValid = false
                    this.cardNumberError = event.error.message
                } else if (!event.complete) {
                    this.cardNumberValid = false
                    this.cardNumberError = "Card number is incomplete"
                } else {
                    this.cardNumberValid = true
                    this.cardNumberError = null
                }
                this.displayError(event, "card-number-error")
            })

            this.cardExpiry.on("change", (event) => {
                if (event.error) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = event.error.message
                } else if (!event.complete) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = "Card number is incomplete"
                } else {
                    this.cardExpiryValid = true
                    this.cardExpiryError = null
                }
                this.displayError(event, "card-expiry-error")
            })

            this.cardCvc.on("change", (event) => {
                if (event.error) {
                    this.cardCvcValid = false
                    this.cardCvcError = event.error.message
                } else if (!event.complete) {
                    this.cardCvcValid = false
                    this.cardCvcError = "Card number is incomplete"
                } else {
                    this.cardCvcValid = true
                    this.cardCvcError = null
                }
                this.displayError(event, "card-cvc-error")
            })

            globals.$loader.hide();
        },

        displayError(event, elementId) {
            let errorContainer = document.getElementById(elementId);
            if (event.error) {

                errorContainer.innerHTML = `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${event.error.message}</p>`
                if (elementId === "card-number-error") this.cardNumberError = event.error.message;
                if (elementId === "card-expiry-error") this.cardExpiryError = event.error.message;
                if (elementId === "card-cvc-error") this.cardCvcError = event.error.message;
            } else {
                errorContainer.innerHTML = ''
                if (elementId === "card-number-error") this.cardNumberError = null;
                if (elementId === "card-expiry-error") this.cardExpiryError = null;
                if (elementId === "card-cvc-error") this.cardCvcError = null;
            }
        },

        destroy() {

            this.cardNumber.destroy();

            this.cardExpiry.destroy();

            this.cardCvc.destroy();
        },

        checkValidation() {
            let isValid = true;

            const refsToValidate = [
                this.$refs.cardHolderName,
            ];
            let firstInvalidRef = null;
            // Validate each ref
            for (const ref of refsToValidate) {
                if (ref?.validate?.()) {
                    if (!firstInvalidRef) firstInvalidRef = ref;
                }
            }
            // Cardholder Name
            if (firstInvalidRef) {
                isValid = false;
            }
            // Stripe elements errors
            if (this.cardNumberError) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardNumberError}</p>`;
                isValid = false;
            }
            if (this.cardExpiryError) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardExpiryError}</p>`;
                isValid = false;
            }
            if (this.cardCvcError) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardCvcError}</p>`;
                isValid = false;
            }
            if (!this.cardNumberError && !this.cardNumber._complete) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Card number field is required</p>`;
                isValid = false;
            }
            if (!this.cardExpiryError && !this.cardExpiry._complete) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Expiry date field is required</p>`;
                isValid = false;
            }
            if (!this.cardCvcError && !this.cardCvc._complete) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">CVC field is required</p>`;
                isValid = false;
            }

            return isValid;
        },

        async getData() {
            const { token, error } = await this.$stripe.createToken(this.cardNumber)
            return { token, error }
        },

        onBegin() {
            //this.isSignatureValid = false
            this.$refs.signaturePad.resizeCanvas();
            if (this.saveSignatureTimeout) {
                clearTimeout(this.saveSignatureTimeout);
            }
        },

        onEnd() {
            this.saveSignatureTimeout = setTimeout(() => {
                this.saveSignature();
            }, 1000);
            this.isSignatureValid = true
        },

        async saveSignature() {
            let result = { isEmpty: true, data: null }
            if (this.$refs.signaturePad) result = this.$refs.signaturePad.saveSignature();
            if (!result.isEmpty) {
                this.signationImageFile = await this.base64ToFile(result.data, "signature.png");
            }
        },

        base64ToFile(base64String, filename) {
            const arr = base64String.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },

        getSignature() {
            return this.signationImageFile
        },

        clearSignature() {
            this.$refs.signaturePad.clearSignature()
            this.isSignatureValid = false
            this.signationImageFile = null
            this.saveSignatureTimeout = null
        },

        async submitForm() {

            if (this.checkValidation()) {
                globals.$loader.show();
                let payload = await this.getData()
                if (payload.error) {
                    globals.$loader.hide();
                    toast.error(payload?.error?.message ?? 'Something went wrong.');
                    return
                }
                let signatureFile = this.getSignature()
                if (!signatureFile) {
                    globals.$loader.hide();
                    toast.error('Something went wrong.');
                    return
                }

                globals.$loader.hide();
                let formData = {
                    card_token: payload.token.id,
                    card_holder_name: this.cardHolderName,
                    signature_image: signatureFile
                }
                this.$emit('submitDetail', formData);
            }
        },

        termsClicked() {

        }

    },

}
</script>